<svg xmlns="http://www.w3.org/2000/svg"
    viewBox="-1 0 2 1"
    width="1px"
    preserveAspectRatio="none">
    <line x1="0" x2="0" y1="0" y2="1"
    vector-effect="non-scaling-stroke"
    stroke="currentColor"/>
</svg>